import { useTranslation } from 'next-i18next';
import { HeroMenuComponentInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

interface HeroMenuSettingsTableInterface {
  component: HeroMenuComponentInterface;
  onChange: (c: HeroMenuComponentInterface) => void;
}

const HeroMenuSettingsTable = ({ component, onChange }: HeroMenuSettingsTableInterface) => {
  const { t } = useTranslation(['pagebuilder']);

  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          type: 'text',
          path: 'preText',
          label: t('pagebuilder:preText'),
        },
        {
          type: 'text',
          path: 'postText',
          label: t('pagebuilder:postText'),
        },
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} showTitleAndDescription={false} />;
};
export default HeroMenuSettingsTable;
